import toNumber from "lodash/toNumber";
import isNumber from "lodash/isNumber";
import { MetaType } from "core/enums";

const isNumericRegex = new RegExp(/^[0-9]+(\.[0-9]+)?$/);

export function getSanitizedAttributeValue(attributeValue, data_type) {
  if (attributeValue === undefined || !data_type) {
    return null;
  }

  let sanitizedValue = attributeValue;

  if (
    data_type?.id === MetaType.NUMBER &&
    !isNumber(attributeValue) &&
    attributeValue.match(isNumericRegex)
  ) {
    sanitizedValue = toNumber(attributeValue);
  }

  if (data_type?.id === MetaType.DATE && attributeValue instanceof Date) {
    const unixDate = parseInt(
      (new Date(attributeValue).getTime() / 1000).toFixed(0)
    );
    sanitizedValue = unixDate;
  }

  return sanitizedValue;
}
